import { IFont, IFontFamily, IMruEntry } from '../FontPicker/FontPicker.types.shared';

/**
 * Search for a font family or font name or mru entry with the specified name.
 * @param fontName - Font name to be searched
 * @param currentFonts - The list of all fonts
 * @param currentMruList - The list of MRU entries
 * @returns The found IFont or undefined if no font is found.
 */
export function findFontOrVariant(
    fontName: string,
    currentFonts: IFontFamily[],
    currentMruList: IMruEntry[]
): IFont | undefined {
    // Font names are case insensitive.
    const lowercaseFontName = fontName.toLocaleLowerCase();

    // check if the string matches one of the existing Mru entry
    const matchedMruEntry = currentMruList.find(
        (item) => item.name.toLocaleLowerCase() === lowercaseFontName
    );
    if (matchedMruEntry) {
        return matchedMruEntry;
    }

    // if no Mru entry matches, search through the Font Families to find a matching font
    const matchedFontFamily = currentFonts.find(
        (f) => f.name.toLocaleLowerCase() === lowercaseFontName
    );

    if (matchedFontFamily) {
        return matchedFontFamily;
    }

    // If not, search through the list of all font variants to find a matching one.
    for (let i = 0; i < currentFonts.length; ++i) {
        const f = currentFonts[i];
        if (!f.submenu) {
            continue;
        }

        const matchedFontVariant = f.submenu.variants.find(
            (variant) => variant.name.toLocaleLowerCase() === lowercaseFontName
        );

        if (matchedFontVariant) {
            return matchedFontVariant;
        }
    }
}
